import { brandBriefTypeHasTitle } from 'src/data/brief';
import { formatPersonaPromptComponent } from './prompt';

export const serializePromptComponent = (promptComponent) =>
  promptComponent.map((line) => `${line.title}: ${line.value}`).join('\n');

export const convertBrandBriefToPromptComponent = (brandBrief) => {
  const result = [];

  const hasTitle = brandBriefTypeHasTitle(brandBrief.briefType);
  if (hasTitle) {
    result.push({
      title: 'Product name',
      value: brandBrief.title,
    });
  }
  result.push({
    title: hasTitle ? 'Product description' : 'Asset',
    value: brandBrief.body,
  });
  return result;
};

export const convertTalkingPointToPromptComponent = (talkingPoint) => [
  {
    title: 'Use this talking point',
    value: talkingPoint.name,
  },
];

export const convertToneOfVoiceToPromptComponent = (toneOfVoice) => [
  {
    title: 'Use this tone of voice',
    value: toneOfVoice.description || toneOfVoice.name,
  },
];

export const convertBrandTermToPromptComponent = (brandTerm) => [
  {
    title: 'Don’t use this term',
    value: brandTerm.term,
  },
];

export const convertMultipleBrandTermsToPromptComponent = (brandTerms) => [
  {
    title: 'Don’t use these terms',
    value: brandTerms.map(({ term }) => term).join(', '),
  },
];

export const convertPersonaToPromptComponent = (persona) => [
  {
    title: 'Customer persona to write for',
    value: formatPersonaPromptComponent(persona),
  },
];
